import * as React from "react";
import { Search } from "lucide-react";
import Input from "@/components/forms/Input";
import { cn } from "@/lib/utils";

export default function SearchInput({ className, ...props }: React.ComponentProps<"input">) {
    return (
        <div className={cn("relative", className)}>
            <Search
                size={16}
                className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
            />
            <Input type="search" className="pl-8" {...props} />
        </div>
    );
}
